import React from 'react'

import 'swiper/scss'

const Card = ({ slide, imageSize }) => {
  const { heading, background_image, description } = slide
  return (
    <swiper-slide>
      <div className='card-wrapper'>
        <div className={`card-image ${imageSize}`}>
          <img src={background_image.url} alt={background_image.alt} />
        </div>
        <div className='card-content'>
          <h4 className='card-heading'>{heading}</h4>
          <p className='card-description paragraph'>{description}</p>
        </div>
      </div>
    </swiper-slide>
  )
}

export default Card
